<script setup lang="ts">
const props = defineProps({
  isOpen: {
    type: Boolean,
    required: true,
    default: true,
  },
  activeSubmissionId: {
    type: String,
    required: false,
    default: null,
  },
});

const emit = defineEmits(["toggle", "select"]);

const companionStore = useCompanion();
const { selectedProfileId } = storeToRefs(companionStore);

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};
</script>

<template>
  <div
    class="bg-white border-l border-gray-200 h-full flex flex-col transition-all duration-300 ease-in-out"
  >
    <div class="p-4 pt-4 flex justify-between items-center min-w-[250px]">
      <h2 class="font-bold text-gray-800 text-lg">My Documents</h2>
      <BaseIconButton
        v-if="activeSubmissionId"
        @click="$emit('toggle')"
        icon="close"
        variant="text"
        class="text-gray-500"
      >
        <BaseIconClose class="w-5 h-5" />
      </BaseIconButton>
    </div>

    <div class="px-4 pb-2 min-w-[250px]" v-if="activeSubmissionId">
      <NuxtLink :to="useCreateCompanionPortalRoute('/')">
        <BaseButton class="w-full justify-center" variant="primary" size="sm">
          <div class="flex items-center">
            <BaseIconPlusCircle class="w-4 h-4 mr-2" /> New Document
          </div>
        </BaseButton>
      </NuxtLink>
    </div>

    <div class="h-[2px] bg-gray-100 rounded mb-2 mx-2" />

    <div class="flex-1 overflow-y-auto min-w-[250px] px-2">
      <DocumentsInfiniteList
        v-if="selectedProfileId"
        :key="selectedProfileId"
        :profile-id="selectedProfileId"
        :states="[
          DocumentState.graded,
          DocumentState.grading,
          DocumentState.submitted,
          DocumentState.studentReview,
          DocumentState.evaluating,
          DocumentState.editing,
          DocumentState.studentCompleted,
        ]"
        :filter-documents="false"
      >
        <template #default="{ document, archiveDocument }">
          <CompanionSidebarDocument
            :submitted-document="document"
            @delete="archiveDocument"
          />
        </template>
      </DocumentsInfiniteList>
    </div>
  </div>
</template>
